<template>
  <v-navigation-drawer v-model='drawer' absolute temporary width='200'>
    <v-list>
      <v-list-tile v-for='item in items' :key='item.title' :id='item.route' v-if='isUserInRole(item.roles)' @click='onItemClick(item, $event)'>
        <v-list-tile-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex'
import CognitoService from '../services/CognitoService'
import AuthenticationService from '../services/AuthenticationService'

export default {
  name: 'ZlickNavigation',
  data () {
    return {
      routePath: 'ppp',
      items: [
        {
          title: this.$t('transactions'),
          icon: 'dashboard',
          route: 'transactions',
          roles: ['admin', 'support', 'analyst']
        },
        {
          title: this.$t('orders'),
          icon: 'subscriptions',
          route: 'subscriptions',
          roles: ['admin', 'support', 'analyst']
        },
        {
          title: this.$t('webhook_logs'),
          icon: 'connect_without_contact',
          route: 'webhookLogs',
          roles: ['techsupport']
        },
        {
          title: this.$t('telemarketing'),
          icon: 'phone',
          route: 'telemarketing',
          roles: ['admin', 'telemarketing']
        },
        {
          title: this.$t('Manage users'),
          icon: 'manage_accounts',
          route: 'manageusers',
          roles: ['admin']
        },
        {
          title: this.$t('addsubscriber'),
          icon: 'person_add',
          route: 'addsubscriber',
          roles: ['manual_subs']
        },
        {
          title: this.$t('reports'),
          icon: 'insights',
          route: 'reports',
          roles: ['admin', 'support', 'analyst']
        }
      ],
      right: null
    }
  },
  methods: {
    setDrawerFalse () {
      this.$store.commit('setDrawer', false)
      this.$store.commit('setSearchValue', null)
      this.$store.commit('setDateRange', {})
    },
    onItemClick (item, event) {
      if (item.route === 'reports') {
        event.preventDefault()
        this.askForMetabaseAccountOrRedirect()
      } else {
        this.$router.push(item.route)
      }

      this.setDrawerFalse()
    },
    askForMetabaseAccountOrRedirect () {
      if (!AuthenticationService.isInRole(['admin', 'support', 'analyst'])) throw new Error('Permission denied. Cannot access reports')

      if (CognitoService.hasMetabaseId()) {
        this.openMetabaseLink()
      } else {
        CognitoService.askToCreateMetabaseAccount(this.$toast)
      }
    },
    openMetabaseLink () {
      window.open('https://data.zlickpay.com', '_blank')
    }
  },

  computed: {
    ...mapGetters(['isUserInRole']),
    drawer: {
      get: function () {
        return this.$store.state.drawer
      },
      set: function (newValue) {
        this.$store.commit('setDrawer', newValue)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ZlickNavigation.vue